import { render, staticRenderFns } from "./EventStatistics.vue?vue&type=template&id=205692f0&scoped=true&"
import script from "./EventStatistics.vue?vue&type=script&lang=js&"
export * from "./EventStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EventStatistics.vue?vue&type=style&index=0&id=205692f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205692f0",
  null
  
)

export default component.exports